<template>
  <van-form ref="vanForm" validate-first class="mode">
    <van-cell-group>
      <template v-for="(item, key) of form">
        <van-field
          v-if="item.isSelect"
          :key="item.name"
          input-align="right"
          v-model="item.text"
          :label="item.name"
          :rules="item.sfkxg && item.value ? item.rules : []"
          placeholder="请选择"
          right-icon="arrow"
          readonly
          @click="showPop(item.name, key, item.sfkxg)"
          :disabled="!item.sfkxg"
        />
        <van-field
          v-else-if="item.isDate"
          :key="item.name"
          input-align="right"
          v-model="item.text"
          :label="item.name"
          :rules="item.sfkxg && item.value ? item.rules : []"
          placeholder="请选择"
          right-icon="arrow"
          readonly
          @click="showDatePop(item.name, key, item.sfkxg)"
          :disabled="!item.sfkxg"
        />
        <van-field
          v-else
          :key="item.name"
          input-align="right"
          v-model="item.text"
          :label="item.name"
          :rules="item.sfkxg && item.value ? item.rules : []"
          placeholder="请输入"
          @input="val => changeValue(val, key)"
          :disabled="!item.sfkxg"
        />
      </template>
    </van-cell-group>
    <van-popup v-model="showDate" round position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :title="textList.title"
        :min-date="minDate"
        @confirm="
          (value, index) => {
            onConfirmDate(value, index, textList.field);
          }
        "
      />
    </van-popup>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="textList.title"
        show-toolbar
        :columns="textList.columns"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index, textList.field);
          }
        "
      />
    </van-popup>
  </van-form>
</template>

<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      form: {},
      show: false,
      currentDate: new Date(),
      minDate: new Date(1900, 0, 1),
      showDate: false,
      textList: {
        title: "",
        field: "",
        columns: []
      },
      columns: {}
    };
  },
  created() {
    this.getList();
  },
  methods: {
    changeValue(val, field) {
      this.form[field].value = val;
    },
    async saveData() {
      this.$refs.vanForm.validate().then(
        async () => {
          let needField = [];
          for (let key in this.form) {
            let item = this.form[key];
            if (item.name === "火车到站") {
              if (item.text !== item.oldValue) {
                if (item.text == "") {
                  item.text = "null";
                }
                needField.push(
                  key +
                    ":" +
                    item.name +
                    ":" +
                    item.dm +
                    ":" +
                    item.oldValue +
                    ":" +
                    item.text
                );
              }
            } else {
              if (item.value !== item.oldValue) {
                if (item.value == "") {
                  item.value = "null";
                }
                needField.push(
                  key +
                    ":" +
                    item.name +
                    ":" +
                    item.dm +
                    ":" +
                    item.oldValue +
                    ":" +
                    item.value
                );
              }
            }
          }
          const res = await Api.saveXjxx({
            type: "jbxx",
            needField: needField.join(",")
          });
          if (res.code == 1) {
            this.$toast.success("学籍基本信息修改已提交");
            setTimeout(() => {
              this.$router.replace("/xsxxxgsq/index");
            }, 1500);
          }
        },
        () => {}
      );
    },
    async getList() {
      const res = await Api.findStudentInfo({ type: "jbxx" });
      if (res.code === "1") {
        let info = res.data.XsInfoMap;
        this.form = {
          cym: {
            name: "曾用名",
            isSelect: false,
            dm: "33",
            text: info.cym,
            value: info.cym,
            oldValue: info.cym
          },
          csrq: {
            name: "出生日期",
            isSelect: false,
            isDate: true,
            dm: "36",
            text:
              info.csrq.substr(0, 4) +
              "年" +
              info.csrq.substr(4, 2) +
              "月" +
              info.csrq.substr(6, 2) +
              "日",
            value: info.csrq,
            oldValue: info.csrq
          },
          mzm: {
            name: "民族",
            isSelect: true,
            dm: "38",
            text: info.mzmc,
            value: info.mzdm,
            oldValue: info.mzdm
          },
          zzmmm: {
            name: "政治面貌",
            isSelect: true,
            dm: "40",
            text: info.zzmm,
            value: info.zzdm,
            oldValue: info.zzdm
          },
          hyzkm: {
            name: "婚姻状况",
            isSelect: true,
            dm: "41",
            text: info.hyzkmc,
            value: info.hyzkdm,
            oldValue: info.hyzkdm
          },
          yzbm: {
            name: "邮政编码",
            isSelect: false,
            dm: "42",
            text: info.yzbm,
            value: info.yzbm,
            oldValue: info.yzbm,
            rules: [
              {
                pattern: /^(0[1-7]|1[0-356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[0-5]|8[013-6])\d{4}$/,
                message: "请输入正确的邮政编码"
              }
            ]
          },
          dh: {
            name: "电话",
            isSelect: false,
            dm: "43",
            text: info.dh,
            value: info.dh,
            oldValue: info.dh,
            rules: [
              {
                pattern: /\d{1}|\d-\d-\d/,
                message: "请输入正确的电话"
              }
            ]
          },
          xmpy: {
            name: "姓名拼音",
            isSelect: false,
            dm: "44",
            text: info.xmpy,
            value: info.xmpy,
            oldValue: info.xmpy
          },
          xxm: {
            name: "血型",
            isSelect: true,
            dm: "45",
            text: info.xx,
            value: info.xxdm,
            oldValue: info.xxdm
          },
          txdz: {
            name: "通讯地址",
            isSelect: false,
            dm: "46",
            text: info.txdz,
            value: info.txdz,
            oldValue: info.txdz
          },
          hcdz: {
            name: "火车到站",
            isSelect: true,
            dm: "48",
            text: info.hcdz,
            value: info.hcdzdm,
            oldValue: info.hcdz
          },
          yhzh: {
            name: "银行账号",
            isSelect: false,
            dm: "49",
            text: info.yhzh,
            value: info.yhzh,
            oldValue: info.yhzh,
            rules: [
              {
                pattern: /^([1-9]{1}(\d{15}|\d{16}|\d{18}))$/,
                message: "请输入正确的银行账号"
              }
            ]
          },
          bz: {
            name: "学生备注",
            isSelect: false,
            dm: "50",
            text: info.bz,
            value: info.bz,
            oldValue: info.bz
          },
          sfzz: {
            name: "是否在职",
            isSelect: true,
            dm: "0",
            text: info.sfzzmc,
            value: info.sfzz,
            oldValue: info.sfzz
          }
          // sskzpc: {
          //   name: "所属控制批次",
          //   isSelect: false,
          //   dm: "0",
          //   text: info.sskzpcmc,
          //   value: info.sskzpcid,
          //   oldValue:info.sskzpcid,
          // }
        };
        for (let key in this.form) {
          this.form[key].sfkxg = true;
        }
        res.data.cloumStatrusList.forEach(item => {
          for (let key in this.form) {
            if (this.form[key].name === item.table_name) {
              this.form[key].sfkxg = item.sfkxg === "1";
              continue;
            }
          }
        });
        let defaultXx = 0;
        let defaultHcdz = 0;
        let defaultHyzk = 0;
        let defaultZzmm = 0;
        let defaultKzpc = 0;
        let defaultMz = 0;
        // 民族
        this.columns.mzm = [
          {
            values: res.data.selectDataMap.mz.map((item, index) => {
              if (item.dm === info.mzdm) {
                defaultMz = index;
              }
              return {
                text: item.dmmc,
                value: item.dm
              };
            }),
            defaultIndex: defaultMz
          }
        ];
        // 政治面貌
        this.columns.zzmmm = [
          {
            values: res.data.selectDataMap.zzmm.map((item, index) => {
              if (item.dm === info.zzdm) {
                defaultZzmm = index;
              }
              return {
                text: item.dmmc,
                value: item.dm
              };
            }),
            defaultIndex: defaultZzmm
          }
        ];
        // 婚姻状况
        this.columns.hyzkm = [
          {
            values: res.data.selectDataMap.hyzk.map((item, index) => {
              if (item.dm === info.hyzkdm) {
                defaultHyzk = index;
              }
              return {
                text: item.dmmc,
                value: item.dm
              };
            }),
            defaultIndex: defaultHyzk
          }
        ];
        // 血型
        this.columns.xxm = [
          {
            values: res.data.selectDataMap.xx.map((item, index) => {
              if (item.dm === info.xxdm) {
                defaultXx = index;
              }
              return {
                text: item.dmmc,
                value: item.dm
              };
            }),
            defaultIndex: defaultXx
          }
        ];
        // 火车到站
        this.columns.hcdz = [
          {
            values: res.data.selectDataMap.hcdz.map((item, index) => {
              if (item.dm === info.hcdzdm) {
                defaultHcdz = index;
              }
              return {
                text: item.dmmc,
                value: item.dm
              };
            }),
            defaultIndex: defaultHcdz
          }
        ];
        // 是否在职
        this.columns.sfzz = [
          {
            values: [{ text: "否", value: "0" }, { text: "是", value: "1" }],
            defaultIndex: Number(info.sfzz)
          }
        ];
        // 所属控制批次
        this.columns.sskzpc = [
          {
            values: res.data.selectDataMap.kzpcList.map((item, index) => {
              if (item.xjxxhdkzid === info.sskzpcid) {
                defaultKzpc = index;
              }
              return {
                text: item.name,
                value: info.xjxxhdkzid
              };
            }),
            defaultIndex: defaultKzpc
          }
        ];
      }
    },
    showDatePop(title, field, flag) {
      if (flag) {
        if (this.form[field].value) {
          let yy = this.form[field].value.substr(0, 4);
          let mm = this.form[field].value.substr(4, 2);
          let dd = this.form[field].value.substr(6, 2);
          this.currentDate = new Date(yy, mm - 1, dd);
        } else {
          this.currentDate = new Date();
        }

        this.showDate = true;
        this.textList.title = title;
        this.textList.field = field;
      }
    },
    onConfirmDate(date, index, field) {
      this.showDate = false;
      let yy = date.getFullYear();
      let mm =
        Number(date.getMonth()) + 1 < 10
          ? "0" + (Number(date.getMonth()) + 1)
          : Number(date.getMonth()) + 1;
      let dd = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      this.form[field].text = yy + "年" + mm + "月" + dd + "日";
      this.form[field].value = yy + "" + mm + "" + dd;
    },
    // 弹出选择器
    showPop(title, field, flag) {
      if (flag) {
        this.show = true;
        this.textList.title = title;
        this.textList.field = field;
        this.textList.columns = this.columns[field];
      }
    },
    // 选择确认
    onConfirm(value, index, field) {
      this.show = false;
      this.form[field].text = value[0].text;
      this.form[field].value = value[0].value;
      //   this.getList();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/newPages/student/xsxxxgsq/mode/jbxx.vue